/**
 * Column definitions for the Direct Delivery and Warehouse Delivery modal tables.
 * Used with the LocalColumnManager for hide/show/sort.
 */

export interface LocalColumn {
  id: string;
  label: string;
  visible: boolean;
  sortOrder: number;
}

export const DEFAULT_DIRECT_COLUMNS: LocalColumn[] = [
  { id: 'delivery_date', label: 'Req. Delivery', visible: true, sortOrder: 0 },
  { id: 'item_code', label: 'Item Code', visible: true, sortOrder: 1 },
  { id: 'description', label: 'Description', visible: true, sortOrder: 2 },
  { id: 'ship_to_address', label: 'Ship to Address', visible: true, sortOrder: 3 },
  { id: 'postcode', label: 'Postcode', visible: true, sortOrder: 4 },
  { id: 'bp_reference', label: 'BP Reference', visible: true, sortOrder: 5 },
  { id: 'creation_date', label: 'Creation Date', visible: true, sortOrder: 6 },
  { id: 'date_updated', label: 'Date Updated', visible: true, sortOrder: 7 },
  { id: 'drop_number', label: 'Drop#', visible: true, sortOrder: 8 },
  { id: 'so_number', label: 'SO#', visible: true, sortOrder: 9 },
  { id: 'customer', label: 'Customer', visible: true, sortOrder: 10 },
  { id: 'fill_percent', label: 'Fill%', visible: true, sortOrder: 11 },
];

/**
 * Warehouse delivery columns — order mirrors StockPlanningColumnPreference.COLUMN_CHOICES
 * so the New Call Off grid matches the Stock Planning grid. Columns without an obvious
 * call-off value are hidden by default but can be enabled via the column manager.
 */
export const DEFAULT_WAREHOUSE_COLUMNS: LocalColumn[] = [
  { id: 'part_number', label: 'Part Number', visible: true, sortOrder: 0 },
  { id: 'description', label: 'Description', visible: true, sortOrder: 1 },
  { id: 'pallet_qty', label: 'Pallet Qty', visible: true, sortOrder: 2 },
  { id: 'load_qty', label: 'Load Qty', visible: true, sortOrder: 3 },
  { id: 'stock_status', label: 'Stock Status', visible: false, sortOrder: 4 },
  { id: 'stock_with_supplier', label: 'Stock With Supplier', visible: true, sortOrder: 5 },
  { id: 'min_stock', label: 'Min Stock', visible: false, sortOrder: 6 },
  { id: 'max_stock', label: 'Max Stock', visible: false, sortOrder: 7 },
  { id: 'all_sal_committed', label: 'All SAL Committed', visible: true, sortOrder: 8 },
  { id: 'committed_by_date', label: 'Committed By Date', visible: true, sortOrder: 9 },
  { id: 'ordered_overall', label: 'Ordered Overall', visible: false, sortOrder: 10 },
  { id: 'ordered_by_supplier', label: 'Ordered By Supplier', visible: false, sortOrder: 11 },
  { id: 'available_to_call_off', label: 'Avail To Call Off', visible: true, sortOrder: 12 },
  { id: 'in_transit', label: 'In Transit', visible: true, sortOrder: 13 },
  { id: 'pf', label: 'PF', visible: false, sortOrder: 14 },
  { id: 'forecast_week_1', label: 'Forecast Wk 1', visible: false, sortOrder: 15 },
  { id: 'forecast_week_2', label: 'Forecast Wk 2', visible: false, sortOrder: 16 },
  { id: 'forecast_week_3', label: 'Forecast Wk 3', visible: false, sortOrder: 17 },
  { id: 'forecast_week_4', label: 'Forecast Wk 4', visible: false, sortOrder: 18 },
  { id: 'sum_of_forecast', label: 'Sum Of Forecast', visible: false, sortOrder: 19 },
  { id: 'sum_on_saltney', label: 'Sum On Saltney', visible: true, sortOrder: 20 },
  { id: 'sum_on_direct', label: 'Sum On Direct', visible: true, sortOrder: 21 },
  { id: 'needed_for_directs', label: 'Needed For Directs', visible: true, sortOrder: 22 },
  { id: 'directs_covered', label: 'Directs Covered', visible: false, sortOrder: 23 },
  { id: 'in_min', label: 'In Min', visible: false, sortOrder: 24 },
  { id: 'in_max', label: 'In Max', visible: false, sortOrder: 25 },
  { id: 'open_po_directs_committed', label: 'Open PO Directs', visible: false, sortOrder: 26 },
  { id: 'current_shortage', label: 'Current Shortage', visible: false, sortOrder: 27 },
  { id: 'po_left_to_call_off', label: 'PO Left To Call Off', visible: true, sortOrder: 28 },
  { id: 'stock_health_min', label: 'Stock Health Min', visible: true, sortOrder: 29 },
  { id: 'stock_health_max', label: 'Stock Health Max', visible: true, sortOrder: 30 },
  { id: 'sh_plus_min', label: 'SH Plus Min', visible: false, sortOrder: 31 },
  { id: 'sh_plus_max', label: 'SH Plus Max', visible: false, sortOrder: 32 },
];
